/** @jsx h */
import { labels } from '../config';
import TeaserGeneral from '../components/TeaserGeneral';
import TeaserArticle from '../components/TeaserArticle';

const ResultContainer = ({
  searchType,
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  switch (searchType) {
    case 'global':
      return (
        <TeaserGeneral
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );
    case 'news':
      return (
        <TeaserArticle
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );

    default:
      return labels.search.unavailable;
  }
};

export default ResultContainer;
